export default "__VITE_ASSET__DyzXMO_E__"